
export const common = {
  // Navigation
  home: "Início",
  features: "Principais Vantagens",
  cases: "Casos de Sucesso",
  pricing: "Preços dos Serviços",
  about: "Sobre Nós",
  getStarted: "Começar",
  language: "Português",
  
  // Hero Section
  heroSubtitle: "Flidge - Localização de excelência para games",
  heroTitle1: "Permita que jogadores do mundo todo",
  heroTitle2: "entendam de verdade o seu jogo",
  heroDescription: "Com tecnologia de IA avançada, oferecemos soluções de tradução multilíngue precisas, rápidas e acessíveis para desenvolvedores, ajudando você a alcançar jogadores e expandir para mercados ao redor do mundo",
  learnMore: "Conheça as Vantagens",
  freeTrial: "Teste Gratuito",
  socialProof: "A escolha de mais de 80 desenvolvedoras e publicadoras de games",
  
  // CTA Section
  ctaTitle1: "Faça o mundo",
  ctaTitle2: "se apaixonar pelo seu jogo",

  // Features Section
  featuresSubtitle: "Principais Vantagens",
  featuresTitle: "Localização de jogos eficiente e inteligente",
  
  feature1Title: "Rápido e Eficiente",
  feature1Description: "Traduções precisas e de alta qualidade em ciclos mais curtos: 200 mil caracteres traduzidos em apenas 1 dia. Aumente significativamente a eficiência da localização do seu projeto de jogo. Em comparação com a tradução humana tradicional, reduz drasticamente erros, identifica com precisão diferenças de maiúsculas/minúsculas e pontuação. Qualidade certificada por agências de tradução.",
  
  feature2Title: "Suporte Multilíngue e Multissenário",
  feature2Description: "Oferecemos serviços de tradução em 64 idiomas, com suporte para roteiros de jogos, páginas de lojas, nomes de jogos, glossários, sites oficiais e muito mais. Atendemos de forma abrangente todas as suas necessidades de localização.",
  
  feature3Title: "Suporte a Múltiplos Formatos de Texto",
  feature3Description: "Suporta importação e exportação de múltiplos formatos de texto, permitindo integrar facilmente as traduções ao seu projeto de jogo. Independentemente da engine de jogo utilizada, a integração é sempre eficiente e descomplicada.",
  
  feature4Title: "Localização que Entende de Games",
  feature4Description: "Focado em localização de jogos, com profundo entendimento das necessidades de diferentes contextos: narrativas, diálogos, interfaces e muito mais. Contamos com um extenso glossário de terminologia para garantir expressões naturais e autênticas, permitindo que os jogadores vivenciem seu jogo como se fosse feito para eles.",

  // Feature 1 specific translations - Translation Time Comparison
  translationTimeComparison: "Comparação de Tempo de Tradução",
  basedOnProject: "Com base em projeto de 200 mil caracteres",
  traditionalAgency: "Agência de tradução tradicional",
  aiPlatform: "Tradução Flidge AI",
  "10days": "10 dias",
  "1day": "1 dia",
  "240hours": "240 horas",
  "24hours": "24 horas",

  // Feature 2 specific translations
  glossary: "Glossário",
  gameTermsReference: "Glossário de termos do jogo",
  completed: "Concluído",
  storePage: "Página da Loja",
  storePageDesc: "Nome do jogo, descrição, diferenciais e slogan promocional",
  inProgress: "Em andamento",
  gameStoryTranslation: "Tradução de Narrativa do Jogo",
  gameStoryDesc: "História da missão principal, tramas secundárias",
  pending: "Pendente",

  // Feature 3 specific translations
  more: "Mais",

  // Case Studies Section
  casesSubtitle: "Casos de Sucesso",
  casesTitle: "Ajudando jogos independentes a serem descobertos por jogadores ao redor do mundo",
  casesDescription: "Valorizamos cada oportunidade de colaboração, e nossa missão é ajudar mais jogos independentes a serem vistos por jogadores ao redor do mundo",
  
  // Game Types - Case Studies Section
  platformActionGame: "Jogo de Plataforma e Ação",
  musicRhythmGame: "Jogo de Ritmo Musical",
  actionStealthGame: "Jogo de ação e stealth",
  casualPuzzleGame: "Jogo Études de casual de Quebra-Cabeça",
  roguelikeCardGame: "Jogo de Estratégia de Cartas Roguelike",
  simulationGame: "Jogos de Simulação e Gestão",
  
  // Game Études de case Descriptions
  haakDescription: "Fornecemos suporte de tradução em 14 idiomas para o jogo estilo Metroidvania HAAK, resultando em um aumento de 147% nas vendas mensais",
  museDashDescription: "Fornecemos suporte de tradução em japonês, coreano e inglês para o jogo de ritmo Muse Dash, oferecendo conteúdo localizado de qualidade para milhões de jogadores em todo o mundo",
  kristalaDescription: "Fornecemos suporte de tradução em chinês para o jogo de ação e stealth Kristala e participamos da tradução do nome do jogo e da página da loja",
  lazyMeowDescription: "Localizamos o jogo casual Lazy Meow City para inglês, japonês e coreano, ajudando a conquistar o mercado da região Ásia-Pacífico",
  stoneSquadDescription: "Fornecemos suporte de tradução e localização para StoneSquad em 30 idiomas, incluindo inglês, japonês, coreano, português, espanhol e outros",
  catHotelDescription: "Fornecemos serviços de tradução de história, missões, itens e página na loja em inglês, japonês, chinês simplificado e chinês tradicional para CatHotel, garantindo uma experiência de jogo verdadeiramente localizada",
  
  // Game Results
  result: "Resultado",
  monthlyRevenueGrowth: "Crescimento de receita mensal de 147%",
  playerReviews: "Avaliações de jogadores 98% positivas",
  translationCompleted: "Tradução concluída em 3 dias",
  salesIncrease: "Aumento de vendas de 85%",
  exposureGrowth: "Crescimento de exposição de 200%",
  playerReviews2: "Avaliações de jogadores 96% positivas",

  // Statistics Section
  successMetrics: "Indicadores de Sucesso",
  serviceImpact: "Impacto dos Serviços",
  clientSatisfactionRate: "Satisfação dos clientes",
  translatedCharactersCount: "50M+",
  translatedCharacters: "Palavras Traduzidas",
  servicedCompanies: "Clientes Atendidos",
  avgTranslationSpeedValue: "3,2 segundos",
  avgTranslationSpeed: "Tempo médio por mil palavras",

  // Customer Reviews Section
  customerReviews: "Avaliações de clientes",
  realUserFeedback: "Feedback de usuários reais",

  // Testimonials
  testimonialSarahRole: "Desenvolvedora de Jogos Independente",
  testimonialSarahContent: "Depois de usar a Flidge, a recepção do nosso jogo nos mercados internacionais foi excelente. A qualidade da tradução superou nossas expectativas — os jogadores comentaram que conseguiram passar a história perfeitamente, não parece tradução automática de jeito nenhum.",

  testimonialThijsRole: "Diretor de Estúdio de Jogos",
  testimonialThijsContent: "Desde a tradução inicial do roteiro até o polimento final dos textos, a equipe Flidge demonstrou altíssimo profissionalismo. A compreensão deles sobre a cultura dos games tornou todo o processo de localização muito mais fluido.",

  testimonialEmmaRole: "Gerente de Localização de Jogos",
  testimonialEmmaContent: "Com o serviço de tradução da Flidge, economizamos muito tempo e custos. A tecnologia de IA deles não é apenas rápida, mas também compreende com precisão a terminologia especializada e as nuances culturais presentes no jogo.",

  testimonialDavidRole: "Produtor de Jogos",
  testimonialDavidContent: "Nosso jogo alcançou enorme sucesso nos mercados japonês e coreano, graças ao excelente serviço de localização da Flidge. O profundo entendimento deles sobre a cultura do Leste Asiático tornou as traduções muito mais autênticas.",

  testimonialAlexRole: "Desenvolvedor Independente",
  testimonialAlexContent: "Como uma equipe pequena, nossa maior preocupação era o custo de localização. A Flidge não só oferece preços justos, como também é extremamente eficiente, permitindo nossa entrada em vários mercados externos simultaneamente.",

  testimonialYukiRole: "Planejador de Jogos",
  testimonialYukiContent: "Fiquei impressionado com a compreensão da Flidge sobre a cultura dos jogos japoneses. Eles não apenas traduziram as palavras, mas transmitiram a essência do jogo, permitindo que jogadores do mundo todo tivessem uma experiência autêntica.",
  
  // Pricing Section
  pricingSubtitle: "Preços dos Serviços",
  pricingTitle: "Preços transparentes",
  pricingDescription: "Oferecemos planos de preços flexíveis para atender às necessidades de projetos de diferentes escalas. Cada conta pode aproveitar créditos gratuitos para teste.",
  
  freeTrialTitle: "Créditos Gratuitos para Teste",
  standardPricing: "Padrão",
  standardPricingDescription: "Tarifa padrão após exceder o limite gratuito",
  enterpriseCustom: "Personalizado Empresarial",
  recommended: "Recomendado",
  perCharacter: "Por caractere",
  perLanguage: "Por idioma",
  customPrice: "Personalizado",
  customPlan: "Planos de Preços",
  customPlanDescription: "Preços exclusivos para projetos de grande porte",

  // New Pricing Calculator Section
  priceCalculator: "Calculadora de Preços",
  calculatorDescription: "Calcule rapidamente o custo de tradução do seu projeto",
  charactersCount: "Quantidade de caracteres",
  targetLanguagesCount: "Idiomas de destino",
  estimatedCost: "Custo estimado",
  calculationNotes: "Detalhes do cálculo",
  calculationDetails: {
    freeQuota: "Cada parceiro possui 5.000 caracteres gratuitos (limitado a um idioma)",
    pricing: "Caracteres adicionais: $0,011/caractere/idioma",
    bulkDiscount: "Projetos de grande volume qualificam-se para preços corporativos personalizados",
    finalPrice: "O preço final será determinado pela equipe comercial"
  },

  // Pricing Section Additional
  languagesCount: "Idiomas",
  freeExperience: "Teste Gratuito",
  freeTrialDescription: "Cada parceiro recebe gratuitamente 5.000 caracteres de teste para tradução em um idioma, para você conhecer a qualidade das nossas traduções",

  startUsing: "Começar agora",
  contactBusinessTeam: "Contatar Equipe Comercial",
  
  standardPricingFeatures: {
    languages: "Tradução em 64 idiomas",
    speed: "Tradução de 200 mil caracteres em 24 horas",
    formats: "Suporta diversos formatos de arquivo",
    glossary: "Glossário profissional de terminologia de jogos",
    quality: "Serviços de garantia de qualidade e revisão"
  },
  
  enterpriseFeatures: {
    allStandard: "Inclui todos os recursos da versão padrão",
    manager: "Gerente de conta exclusivo",
    priority: "Processamento prioritário e serviço urgente",
    customGlossary: "Glossário e guia de estilo personalizados",
    discount: "Descontos por volume e condições especiais para contratos de longo prazo",
    extraTrial: "Solicitar créditos extras de teste"
  },

  // New entries added
  professionalTerminologyDatabase: 'Glossário Especializado',
  cheese: 'Cheese',
  feeding: 'Feeding',
  rush: 'Rush',
  balance: 'Balance',
  fightingGamesJapanese: 'Jogos de luta - Japonês',
  mobaGamesKorean: 'Jogos MOBA - Coreano',
  starcraftRussian: 'StarCraft - Russo',
  actionGamesChinese: 'Jogos de ação - Chinês',

  // About Section
  aboutSubtitle: "Sobre Nós",
  aboutTitle: "Equipe Profissional de Serviços de Localização de Jogos",
  aboutDescription: "Fundada em 2019, a Flidge é uma empresa de tecnologia especializada em localização de jogos. Combinamos tecnologia de IA com revisão profissional humana para oferecer serviços de localização multilíngue de alta qualidade e eficiência a desenvolvedores de jogos em todo o mundo, ajudando jogos excepcionais a alcançar o mercado global.",
  
  ourMission: "Nossa Missão",
  ourVision: "Nossa Visão",
  missionText: "Através de tecnologia avançada de IA e serviços profissionais de localização, quebramos barreiras linguísticas para que cada jogo excepcional tenha sucesso no mercado global, permitindo que jogadores de todo o mundo desfrutem de experiências incríveis.",
  visionText: "Ser a plataforma líder mundial em serviços de localização de jogos, contribuindo para o desenvolvimento global da indústria por meio da inovação tecnológica e serviços profissionais, e promovendo a disseminação da excelente cultura de jogos ao redor do mundo.",
  
  // FAQ Section
  faqSubtitle: 'Perguntas Mais Frequentes',
  faqTitle: 'FAQ',
  faqDescription: 'Se tiver mais dúvidas, fique à vontade para entrar em contato conosco',
  
  faq1Question: "Vocês oferecem uma cota de tradução para teste?",
  faq1Answer: "Oferecemos a cada parceiro uma cota de teste de 5.000 caracteres para tradução em um único idioma. Acima desse limite, o valor é de US$ 0,016 por caractere por idioma. Caso necessite de cota adicional para testes, entre em contato com nossa equipe comercial.",
  
  faq2Question: "Em qual estágio do desenvolvimento do jogo é recomendado começar a usar os serviços da Flidge?",
  faq2Answer: "Recomendamos utilizar os serviços da Flidge nas fases intermediárias a finais do desenvolvimento do seu projeto de jogo, o que permitirá reduzir ao máximo os custos de localização. Além disso, podemos fornecer suporte para tradução de páginas de loja e ajudá-lo a selecionar nomes localizados mais adequados para seu jogo, facilitando que os jogadores se lembrem dele e ajudando você a expandir para o mercado global.\nSe seu jogo está prestes a ser lançado em plataformas como Steam, os serviços da Flidge são perfeitos para você. Podemos concluir grandes volumes de trabalho de localização em diversos idiomas em curtíssimo prazo, permitindo que jogadores do mundo inteiro descubram seu jogo.",
  
  faq3Question: "E se meu projeto de jogo não tiver um glossário?",
  faq3Answer: "Podemos oferecer o serviço de organização de glossário pela Flidge AI para ajudá-lo a gerenciar melhor seu projeto e o conteúdo a ser traduzido. Trabalharemos com você para confirmar o uso da terminologia, garantindo que esses termos sejam aplicados corretamente em seu jogo.\nCaso necessite do serviço de organização de glossário, fique à vontade para entrar em contato conosco.",
  
  faq4Question: "Meu conteúdo de jogo será mantido em estrita confidencialidade?",
  faq4Answer: "Utilizamos criptografia de padrão industrial e fluxos de trabalho compartimentalizados especificamente para projetos de jogos. Cada membro da equipe trabalha sob rigorosos acordos de confidencialidade, com penalidades financeiras bem definidas. Nosso ambiente de desenvolvimento garante isolamento completo de ativos — sem capturas de tela, sem drives externos, sem dispositivos pessoais. Compreendemos que vazamentos de imagens do jogo, elementos da história ou datas de lançamento podem prejudicar seriamente o impacto de mercado — sua propriedade intelectual criativa receberá a mesma proteção que exigimos para nossos próprios trabalhos não publicados.",
  
  // Contact Section
  contactSubtitle: "Entre em contato",
  contactTitle: "Obtenha serviços profissionais de tradução e créditos gratuitos",
  contactDescription: "Preencha o formulário abaixo e nossa equipe especializada fornecerá uma proposta detalhada dentro de 24 horas",
  
  name: "Nome",
  email: "E-mail",
  company: "Nome da empresa/estúdio",
  targetLanguages: "Idioma de destino",
  projectDetails: "Detalhes do projeto",
  getQuote: "Solicitar Orçamento",
  onlineConsult: "Consulta online",
  emailContact: "Enviar Email",
  
  // Form placeholders
  namePlaceholder: "Por favor, insira seu nome",
  emailPlaceholder: "Por favor, insira seu endereço de e-mail",
  companyPlaceholder: "Por favor, insira o nome da empresa ou estúdio",
  languagesPlaceholder: "ex.: Inglês, Japonês, Coreano, etc.",
  messagePlaceholder: "Por favor, descreva detalhadamente os requisitos do seu projeto, incluindo tipo de jogo, conteúdo de tradução, requisitos especiais, etc...",
  
  // Form labels
  required: "*",
  characterCount: "caracteres",
  
  // Common Actions
  contactUs: "Entre em contato",
  viewFaq: "Confira o FAQ",
  stillHaveQuestions: "Ficou com dúvidas?",
  
  // Footer
  footerDescription: "Focados em oferecer serviços de localização eficientes e acessíveis para games independentes, ajudamos projetos a alcançarem crescimento global através de tradução inteligente, análise e serviços linguísticos personalizados.",
  services: "Serviços",
  companySection: "Empresa",
  resources: "Principais Vantagens",
  featuresLink: "Principais Vantagens",
  pricingConsult: "Preços dos Serviços",
  aboutUs: "Sobre nós",
  helpCenter: "Centro de ajuda",
  techBlog: "Blog técnico",
  termsOfService: "Termos de Serviço",
  privacyPolicy: "Política de Privacidade",
  cookiePolicy: "Política de Cookies",
  poweredBy: "Powered by Readdy",
  copyright: "© 2025 Flidge AI Serviços de Tradução. Todos os direitos reservados.",
  
  // Partners
  partners: "Parceiros",
  trustedPartners: "Parceiro Confiável",
  partnersDescription: "Estabelecer parcerias profundas e duradouras com as principais equipes e empresas de jogos do mundo",
  
  // Statistics
  stat1Number: '80+',
  stat1Label: 'Empresas atendidas',
  stat2Number: '64',
  stat2Label: 'Idiomas disponíveis',
  stat3Number: '97%',
  stat3Label: 'Índice de satisfação',
  stat4Number: '24h',
  stat4Label: 'Tempo de resposta',
  
  // Terms of Service
  termsTitle: 'Termos de Serviço',
  termsLastUpdated: 'Última atualização: Janeiro 2025',
  terms1Title: '1. Aceitação dos Termos',
  terms1Content: 'Ao acessar e usar os Serviços de Tradução AI da Flidge, você aceita e concorda em estar vinculado aos termos e disposições deste acordo.',
  terms2Title: '2. Licença de Uso',
  terms2Content: 'É concedida permissão para baixar temporariamente uma cópia dos materiais no site da Flidge apenas para visualização pessoal e não comercial.',
  terms3Title: '3. Isenção de Responsabilidade',
  terms3Content: 'Os materiais no site da Flidge são fornecidos "como estão". A Flidge não oferece garantias expressas ou implícitas.',
  terms4Title: '4. Limitações',
  terms4Content: 'Em nenhum caso a Flidge ou seus fornecedores serão responsáveis por quaisquer danos decorrentes do uso ou incapacidade de usar os materiais.',
  terms5Title: '5. Precisão dos Materiais',
  terms5Content: 'Os materiais que aparecem no site da Flidge podem incluir erros técnicos, tipográficos ou fotográficos.',
  terms6Title: '6. Links',
  terms6Content: 'A Flidge não revisou todos os sites vinculados ao nosso site e não é responsável pelo conteúdo de tais sites vinculados.',
  terms7Title: '7. Modificações',
  terms7Content: 'A Flidge pode revisar estes termos de serviço a qualquer momento sem aviso prévio.',
  terms8Title: '8. Lei Aplicável',
  terms8Content: 'Estes termos e condições são regidos e interpretados de acordo com as leis aplicáveis.',
  
  // Privacy Policy
  privacyTitle: 'Política de Privacidade',
  privacyLastUpdated: 'Última atualização: Janeiro 2025',
  privacy1Title: '1. Informações que Coletamos',
  privacy1Content: 'Coletamos informações que você nos fornece diretamente, como quando cria uma conta ou usa nossos serviços de tradução.',
  privacy2Title: '2. Como Usamos Suas Informações',
  privacy2Content: 'Usamos as informações coletadas para fornecer, manter e melhorar nossos serviços de tradução.',
  privacy3Title: '3. Compartilhamento de Informações',
  privacy3Content: 'Não vendemos, negociamos ou transferimos suas informações pessoais para terceiros sem seu consentimento.',
  privacy4Title: '4. Segurança de Dados',
  privacy4Content: 'Implementamos medidas de segurança apropriadas para proteger suas informações pessoais.',
  privacy5Title: '5. Retenção de Dados',
  privacy5Content: 'Retemos suas informações pessoais pelo tempo necessário para fornecer nossos serviços.',
  privacy6Title: '6. Seus Direitos',
  privacy6Content: 'Você tem o direito de acessar, atualizar e solicitar a exclusão de suas informações pessoais.',
  privacy7Title: '7. Cookies e Rastreamento',
  privacy7Content: 'Usamos cookies e tecnologias de rastreamento similares para melhorar sua experiência em nosso site.',
  privacy8Title: '8. Transferências Internacionais',
  privacy8Content: 'Suas informações podem ser transferidas e processadas em países diferentes do seu.',
  privacy9Title: '9. Alterações nesta Política',
  privacy9Content: 'Podemos atualizar esta Política de Privacidade de tempos em tempos.',
  privacy10Title: '10. Entre em Contato',
  privacy10Content: 'Se você tiver dúvidas sobre esta Política de Privacidade, entre em contato conosco em privacy@flidge.ai.',
  
  // Cookie Policy
  cookieTitle: 'Política de Cookies',
  cookieLastUpdated: 'Última atualização: Janeiro 2025',
  cookie1Title: '1. O que são Cookies',
  cookie1Content: 'Cookies são pequenos arquivos de texto colocados em seu dispositivo quando você visita nosso site.',
  cookie2Title: '2. Tipos de Cookies que Usamos',
  cookie2Content: 'Usamos cookies essenciais para funções básicas do site, cookies de desempenho para analisar padrões de uso e cookies funcionais.',
  cookie2Essential: 'Cookies Essenciais',
  cookie2EssentialDesc: 'Estes cookies são necessários para que o site funcione corretamente.',
  cookie2Performance: 'Cookies de Desempenho',
  cookie2PerformanceDesc: 'Estes cookies coletam informações sobre como os visitantes usam nosso site.',
  cookie2Functional: 'Cookies Funcionais',
  cookie2FunctionalDesc: 'Estes cookies permitem que o site lembre das escolhas que você faz.',
  cookie3Title: '3. Cookies de Terceiros',
  cookie3Content: 'Podemos usar serviços de terceiros que colocam cookies em seu dispositivo.',
  cookie4Title: '4. Gerenciando Cookies',
  cookie4Content: 'Você pode controlar e gerenciar cookies através das configurações do seu navegador.',
  cookie5Title: '5. Consentimento de Cookies',
  cookie5Content: 'Ao continuar usando nosso site, você consente com nosso uso de cookies conforme descrito nesta política.',
  cookie6Title: '6. Impacto de Desabilitar Cookies',
  cookie6Content: 'Se você escolher desabilitar cookies, algumas funcionalidades do nosso site podem não funcionar corretamente.',
  cookie7Title: '7. Atualizações desta Política',
  cookie7Content: 'Podemos atualizar esta Política de Cookies de tempos em tempos.',
  cookie8Title: '8. Informações de Contato',
  cookie8Content: 'Se você tiver dúvidas sobre nosso uso de cookies, entre em contato conosco em cookies@flidge.ai.'
};
export default common;
